import { CountryCode } from '~shared/constants/country-code.enum';

export const LATIN_SYMBOLS_PATTERN = /^[\-\s.,'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*$/;
export const LATIN_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*$/;
export const COMPANY_NAME_PATTERN = /^[0-9\-\s.,'+&A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*$/;
export const PROVINCE_PATTERN = /^[A-Z]{2}$/;
export const GERMAN_SYMBOLS_PATTERN = /^[\-\s.,'/A-Za-zÄÖÜäöüß]*$/;
export const GERMAN_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'/A-Za-zÄÖÜäöüß]*$/;
export const ITALIAN_SYMBOLS_PATTERN = /^[\-\s.,'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF’]*$/;
export const ITALIAN_COMPANY_NAME_PATTERN = /^.{1,80}$/;
export const ITALIAN_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'/A-Za-zÄÖÜäöüßéóàèìòù’]*$/;
export const PORTUGUESE_SYMBOLS_PATTERN = /^[\-\s.,'/A-Za-záâãàçéêíóôõúÁÂÃÀÇÉÊÍÓÔÕÚ’]*$/;
export const PORTUGUESE_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'/A-Za-záâãàçéêíóôõúÁÂÃÀÇÉÊÍÓÔÕÚ’]*$/;
export const DUTCH_SYMBOLS_PATTERN = /^[\-\s.,'/A-Za-zÄÖÜäöüß]*$/;
export const DUTCH_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'/A-Za-zÄÖÜäöüß]*$/;
export const NOT_ONLY_SYMBOLS_PATTERN = /(?!^[\-\s.,']+$)^.+$/;
export const NOT_ONLY_ADDRESS_SYMBOLS_PATTERN = /(?!^[\-\s.,'/]+$)^.+$/;
export const REG_EXP_EMAIL_PATTERN = /\S+@\S+\.\S+/;
export const POSTCODE_PATTERN = /^[0-9A-Za-z]*$/;
export const POSTCODE_PATTERN_DE = /^[0-9]*$/;
export const POSTCODE_PATTERN_ES = /^[0-9]*$/;
export const POSTCODE_PATTERN_IT = /^[0-9]*$/;
export const POSTCODE_PATTERN_PT = /^(?!9)\d{4}-\d+$/;
export const POSTCODE_PATTERN_NL = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
export const POSTCODE_PATTERN_FR = /^[0-9]*$/;
export const EMAIL_PATTERN = /^.+@\S+\.\S{2,}$/;
export const NO_METRO_DOMAIN = /^(?!.*@(metro\.(de|it|fr)|makro\.(es|pt|nl)(?![a-zA-Z]))$).*$/;
export const DIGITS_ONLY_PATTERN = /^[0-9]*$/;
export const DIGITS_WITH_CODE_PATTERN = /^\+?\d+$/;
export const PASSWORD_PATTERN = /^[^ ]*$/;
export const PASSWORD_PATTERN_LENGTH = /^.{8,50}$/;
export const TAX_NUMBER_DE_PATTERN_LIST = [
  /^\d{5}\/\d{5}$/,
  /^\d{2,3}\/\d{3}\/\d{5}$/,
  /^\d{3,4}\/\d{4}\/\d{4}$/,
  /^\d{10,13}$/,
];
export const TAX_NUMBER_ES_PATTERN_LIST = [/^\d{8}[A-Za-z]{1}$/, /^[A-Za-z]{1}\d{7}[A-Za-z]{1}$/, /^[A-Za-z]{1}\d{8}$/];

export const TAX_NUMBER_PATTERN_LISTS = {
  [CountryCode.Germany]: TAX_NUMBER_DE_PATTERN_LIST,
  [CountryCode.Spain]: TAX_NUMBER_ES_PATTERN_LIST,
};

export const POSTAL_CODE_DE_PATTERN = /^\d+$/;
export const POSTAL_CODE_ES_PATTERN = /^\d{5}$/;
export const POSTAL_CODE_IT_PATTERN = /^\d{5}$/;
export const POSTAL_CODE_PT_PATTERN = /^\d{4}-\d{3}$/;
export const POSTAL_CODE_NL_PATTERN = /^\d{4}\s*[A-Z]{2}$/;
export const POSTAL_CODE_FR_PATTERN = /^\d{5}$/;

export const POSTAL_CODE_PATTERNS = {
  [CountryCode.Germany]: POSTAL_CODE_DE_PATTERN,
  [CountryCode.Spain]: POSTAL_CODE_ES_PATTERN,
  [CountryCode.Italy]: POSTAL_CODE_IT_PATTERN,
  [CountryCode.Portugal]: POSTAL_CODE_PT_PATTERN,
  [CountryCode.Netherlands]: POSTAL_CODE_NL_PATTERN,
  [CountryCode.France]: POSTAL_CODE_FR_PATTERN,
};

export const PHONE_NUMBER_LENGTH = /^\d{6,15}$/;

export const VAT_DE_PATTERN = /^DE\d{9}$/;

export const VAT_ITALY_PATTERN = /^(IT){0,1}\d{11}$/;
export const VAT_ITALY_PATTERN_TIER_TWO = /^IT\d{11}$/;

export const VAT_PORTUGAL_PATTERN = /^(PT){0,1}\d{9}$/;
export const VAT_PORTUGAL_PATTERN_TIER_TWO = /^PT\d{9}$/;
export const VAT_DUTCH_PATTERN_TIER_TWO = /^\s*(NL){0,1}\d{9}[A-Za-z]{1}\d{2}\s*$/;

export const KVK_NETHERLANDS_PATTERN = /^\d{8}$/;
export const SIREN_FRANCE_PATTERN = /^\d{9}$/;
export const ELECTRONIC_INVOICE_ID = /^[A-Z0-9]{7}$/;

const NEGATE_COMPANY_NAME_PATTERN = /(?![a-zA-Z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF.,\- '])./g;

export const FIELD_NEGATE_PATTERN = {
  firstName: /(?![a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF.,\- '])./g,
  lastName: /(?![a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF.,\- '])./g,
  phoneNumber: 'length',
  invoicePhoneNumber: 'length',
  freightForwardingPhone: 'length',
  postalCode: /(?![0-9])./g,
  city: /(?![a-zA-ZäöüßÄÖÜ.,\-'\/ ])./g,
  companyName: NEGATE_COMPANY_NAME_PATTERN,
  businessName: NEGATE_COMPANY_NAME_PATTERN,
  addressLine: /(?![a-zA-Z0-9äöüßÄÖÜ.,\-'\/ ])./g,
};

export const SPACE_PATTERN = /\s/g;

export const VALID_DAY_PATTERN = /^(0*[1-9]|[12][0-9]|3[01])$/;
export const VALID_MONTH_PATTERN = /^(0*[1-9]|1[0-2])$/;
export const VALID_YEAR_PATTERN = /^([0-9]{4})$/;
export const VALID_DATE_PATTERN = /^\s*(3[01]|[12][0-9]|0?[1-9])\/(1[012]|0?[1-9])\/((?:19|20)\d{2})\s*$/;

export const SPANISH_COMPANY_NAME_PATTERN_LIST = [
  /^[0-9\-\s.!"#$%&'\(\)\*\+-\.\/:;<=>@\[\\\]\^_`\{\|\}]/,
  /^[~ÀàÈèÌìÒòÙùÑñáéíóúýÁÉÍÓÚüÜÇ/,'+&A-Za-z]/,
  /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
];

export const SPANISH_LATIN_SYMBOLS_PATTERN_LIST = [
  /^[\-\s.!"#$%&'\(\)\*\+-\.\/:;<=>@\[\\\]\^_`\{\|\}]/,
  /^[~ÀàÈèÌìÒòÙùÑñáéíóúýÁÉÍÓÚüÜÇ/,'A-Za-z]/,
  /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
];

export const SPANISH_SYMBOLS_PATTERN_LIST = [
  /^[\-\s.!"#$%&'\(\)\*\+-\.\/:;<=>@\[\\\]\^_`\{\|\}]/,
  /^[~ÀàÈèÌìÒòÙùÑñáéíóúýÁÉÍÓÚüÜÇ/,'/A-Za-zÄÖÜäöüß]/,
  /^[,'/A-Za-zÄÖÜäöüß]/,
];

export const SPANISH_SYMBOLS_DIGITS_PATTERN = /^[0-9\-\s.,'/A-Za-zÄÖÜäöüß°ªº]*$/;
export const SPANISH_NOT_ONLY_ADDRESS_SYMBOLS_PATTERN = /(?!^[\-\s.,]+$)^.+$/;
export const IS_UUID = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
